import heic2any from "heic2any";
import createCanvas from "./createCanvas";

const useImageProcessing = () => {
  const createImageCanvas = async ({
    ACTIONS,
    dispatch,
    image,
    selectedPhotoPoint,
    state,
    images,
  }) => {
    try {
      let blobURL = await createCanvas({
        image: image,
        address: state.address,
        selectedPhotoPoint: selectedPhotoPoint,
        featureType: state.selectedFeature.label,
      });
      let index = images.findIndex((img) => img.key === image.key);
      if (index >= 0) {
        images[index].url = blobURL;
      }
      dispatch({
        type: ACTIONS.UPDATE_IMAGE_OBJECTS,
        value: images,
      });
    } catch (e) {
      dispatch({
        type: ACTIONS.SET_STATUS,
        value: `Error creating image canvas: ${e.message}`,
      });
    }
  };

  const createImgObj = async ({
    ACTIONS,
    dispatch,
    imgFile,
    selectedPhotoPoint,
    state,
    images,
  }) => {
    try {
      var image = new Image();
      var url = URL.createObjectURL(imgFile);
      image.src = url;
      image.url = url;
      image.key = imgFile.lastModified.toString();
      image.onload = function () {
        createImageCanvas({
          ACTIONS: ACTIONS,
          dispatch: dispatch,
          image: image,
          selectedPhotoPoint: selectedPhotoPoint,
          state: state,
          images: images,
        });
      };
      return {
        key: imgFile.lastModified.toString(),
        lastModified: imgFile.lastModified,
        lastModifiedDate: imgFile.lastModifiedDate,
        name: imgFile.name,
        size: imgFile.size,
        type: imgFile.type,
        url: url,
      };
    } catch (e) {
      dispatch({
        type: ACTIONS.SET_STATUS,
        value: `Error creating image object: ${e.message}`,
      });
    }
  };

  const duplicateImage = (state, image) => {
    return state.imageObjects.find(
      (img) =>
        image.lastModified === img.lastModified &&
        image.size === img.size &&
        image.type === img.type
    );
  };

  const processUploadedImages = async ({
    ACTIONS,
    dispatch,
    files,
    selectedPhotoPoint,
    state,
  }) => {
    var images = [...state.imageObjects];
    for await (var file of files) {
      try {
        let imgFile = file;
        if (
          imgFile?.name?.toLowerCase().endsWith(".heic") ||
          imgFile?.name?.toLowerCase().endsWith(".heif")
        ) {
          let heicImg = await heic2any({ blob: file, toType: "image/png" });
          heicImg.lastModified = imgFile.lastModified;
          heicImg.lastModifiedDate = imgFile.lastModifiedDate;
          try {
            heicImg.name = imgFile.name.substr(0, imgFile.name.indexOf("."));
          } catch {
            heicImg.name = "";
          }
          imgFile = heicImg;
        }
        var image = await createImgObj({
          ACTIONS: ACTIONS,
          dispatch: dispatch,
          imgFile: imgFile,
          selectedPhotoPoint: selectedPhotoPoint,
          state: state,
          images: images,
        });
        if (duplicateImage(state, image)) {
          dispatch({
            type: ACTIONS.SET_STATUS,
            value: "Duplicate image detected.",
          });
          break;
        }
        images.push(image);
      } catch (e) {
        dispatch({
          type: ACTIONS.SET_STATUS,
          value: `Error processing image: ${e.message}`,
        });
      }
    }
    return images;
  };

  return { processUploadedImages };
};

export default useImageProcessing;
